export { KendoDatePicker } from './src/date-picker';
export { KendoStringDatePicker } from './src/string-date-picker';
